import { object, string } from "yup";
import GeneralInformation from "../../interfaces/general-information.interface";
import Title from "antd/es/typography/Title";

export const generalInfoContent = (
  prop: keyof GeneralInformation,
  title: string,
  generalInfo: GeneralInformation,
) => {
  return (
    <div className="flex flex-col items-baseline px-4">
      <Title level={3} style={{ fontWeight: "400", whiteSpace: "wrap" }}>
        {title}:
      </Title>
      <div
        className="custom-format text-base"
        style={{ fontWeight: "300" }}
        dangerouslySetInnerHTML={{ __html: String(generalInfo[prop]) }}
      />
    </div>
  );
};

export const generalInformationSchema = object({
  programDetails: string(),
  minimumRequirements: string(),
  requirementsAuditing: string(),
  communications: string(),
  electronicSubmission: string(),
  codeConduct: string(),
  importantNotes: string(),
  chequePayable: string(),
  sendChequesForms: string(),
  refunds: string(),
  withdrawal: string(),
  studentCode: string(),
});

export const generalInformationValues = (generalInfo?: GeneralInformation) => {
  return {
    programDetails: generalInfo?.programDetails ?? "",
    minimumRequirements: generalInfo?.minimumRequirements ?? "",
    requirementsAuditing: generalInfo?.requirementsAuditing ?? "",
    communications: generalInfo?.communications ?? "",
    electronicSubmission: generalInfo?.electronicSubmission ?? "",
    codeConduct: generalInfo?.codeConduct ?? "",
    importantNotes: generalInfo?.importantNotes ?? "",
    chequePayable: generalInfo?.chequePayable ?? "",
    sendChequesForms: generalInfo?.sendChequesForms ?? "",
    refunds: generalInfo?.refunds ?? "",
    withdrawal: generalInfo?.withdrawal ?? "",
    studentCode: generalInfo?.studentCode ?? "",
  };
};
